import React from "react";

const Eyebrow = ({ children, light }) => (
  <p
    className={`flex items-center gap-3 mb-5 text-sm font-850 tracking-[0.1em] leading-[1.45] ${
      light ? "text-secondary" : "text-primary"
    }`}
  >
    <span
      className="inline-block w-[34px] h-[3px] bg-secondary flex-none"
      aria-hidden="true"
    />
    {children}
  </p>
);

export default Eyebrow;
